// extracted by mini-css-extract-plugin
export default {"scrollBar":"dob-change-page_scrollBar__QULGc","textAreaScroll":"dob-change-page_textAreaScroll__lkJgo","list":"dob-change-page_list__6hizC dob-change-page_scrollBar__QULGc"};